export default __webpack_public_path__ + "static/media/vintage45g-4.b22da8df.jpg";